<template>
    <div class="flex">
        <div class="w-full text-gray-200">
            <div class="text-center">
                <div class="text-5xl md:text-15xl">{{title}}</div>
                <p class="text-2xl md:text-3xl font-light mb-8 leading-normal">{{message}}</p>
                <a
                    :href="route('casino.home')"
                    class="bg-transparent text-grey-200 font-bold uppercase py-3 px-6 border-2 border-grey-200 hover:border-grey-400 rounded-lg">
                    {{$t('Go Home')}}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        title: String,
        message: String,
    },
}
</script>

<style lang="sass" scoped>

</style>
